// Auto-generated cornerstone translation for en.
// Source: cornerstones/nl.js, translated via Claude Sonnet on 2026-05-28T13:32:41.522434+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Horse management app: best choice for 2026 | EquiSight",
      description: "Compare horse management apps for owners, stables, and breeders. Discover why EquiSight is the complete app for your horse.",
      keywords: [
        "horse management app",
        "stable management app",
        "horse logbook app",
        "app for managing multiple horses",
        "mare pregnancy app",
        "horse breeding app",
        "best horse management app",
      ],
    },
    hero: {
      eyebrow: "Buying guide · horse management software",
      breadcrumbLabel: "Horse management app",
      title: "Horse management app: the complete buying guide for owners, stables, and breeders.",
      intro: "Not just a list of features — an honest comparison, a buying guide, and a look at what a horse management app truly needs to deliver in 2026. For one horse, for an entire stable, or for your breeding operation.",
      pills: [
        {
          icon: "Users",
          label: "For owners",
        },
        {
          icon: "Building2",
          label: "For stables",
        },
        {
          icon: "Baby",
          label: "For breeders",
        },
        {
          icon: "Share2",
          label: "For teams",
        },
      ],
      ctas: [
        {
          label: "Start free with 1 horse",
          href: "#start",
          primary: true,
        },
        {
          label: "Go to comparison table",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Why a horse management app is becoming increasingly important.",
      lead: "Horse management in practice is fragmented: WhatsApp, a calendar, Excel, photos on your phone, a paper passport, loose invoices, and verbal agreements. Already inconvenient with one horse. With multiple horses, breeding operations, or shared care, gaps appear — missed appointments and disputes follow.",
      items: [
        "What was that vaccination date again?",
        "Who paid the farrier?",
        "Which mare needs to be checked today?",
        "Did the trainer actually read last week's instructions?",
        "Did I really save that photo document?",
        "Is the feeding schedule hanging in the stable still accurate?",
      ],
    },
    what: {
      title: "What is a horse management app?",
      lead: "A horse management app is essentially a digital record per horse. No scattered notes — just one place for health, training, nutrition, documents, planning, reminders, costs, photos, videos, and shared access. Everyone involved with the horse looks at the same, up-to-date information.",
      targetGroupsTitle: "Who is a horse management app designed for?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Private owner",
          body: "One horse, one record — health, planning, and history in your pocket.",
        },
        {
          icon: "Users",
          title: "Owner with multiple horses",
          body: "Separate profiles, separate planning, shared task list for the whole team.",
        },
        {
          icon: "Building2",
          title: "Livery yard & riding school",
          body: "Owner access, care instructions, shared calendar, and tasks.",
        },
        {
          icon: "Baby",
          title: "Breeding operation",
          body: "Mare cycle, pregnancy, stallion details, pedigree, and foal development.",
        },
        {
          icon: "Target",
          title: "Trainers",
          body: "Insight per horse, log sessions, set goals, analyse videos.",
        },
        {
          icon: "ClipboardList",
          title: "Professionals",
          body: "Farrier, dentist, physio, or vet — all working from the same record.",
        },
      ],
    },
    criteria: {
      title: "What should a good horse management app deliver?",
      lead: "An app isn't just about looks — it needs to work practically every single day. Five elements that must not be missing from any 2026 shortlist.",
      items: [
        {
          icon: "FileText",
          title: "Horse record per horse",
          body: "Details, age, breed, passport information, owner, stable, photos, and documents — all linked to one horse profile.",
        },
        {
          icon: "Heart",
          title: "Health and care",
          body: "Vaccinations, deworming, farrier, dentist, vet, treatments, medication, and automatic reminders before the due date.",
        },
        {
          icon: "Activity",
          title: "Training and progress",
          body: "Log training sessions, notes, videos, competition results, goals, and progress per discipline or per horse.",
        },
        {
          icon: "Apple",
          title: "Nutrition and management",
          body: "Feeding schedules, supplements, roughage, weight, body condition score, and the daily routine the stable needs to know.",
        },
        {
          icon: "Share2",
          title: "Share with others",
          body: "Access for owner, carer, trainer, yard manager, or professional — with permission settings that suit each role.",
        },
        {
          icon: "Calendar",
          title: "Planning and reminders",
          body: "A shared calendar with tasks, automatic reminders, and confirmations so nothing slips through the cracks.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs other horse management apps.",
      lead: "The Dutch SERP is currently dominated by Stalmanager, LogMyHorse, EquineM, and Happie Horse. Each has its strengths. We place the most-requested features side by side — honestly and based on publicly available information.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Free to start",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Multiple horses",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Health record",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Training & progress",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Nutrition & supplements",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planning & reminders",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Documents per horse",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Team sharing & permissions",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Breeding module (complete)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mare cycle tracking",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Pregnancy planning + scans",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Foal development",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Professional integration",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach insights",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Suitable for owners",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Suitable for breeders",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Suitable for stables/riding schools",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Comparison based on publicly available features as of January 2026. Competitors are also solid tools; EquiSight is built to combine all modules in one app.",
    },
    why: {
      title: "Why EquiSight is different.",
      lead: "A logbook records. EquiSight combines horse management, training, nutrition, health, competitions, professionals, and breeding in one modern app — and goes a step further with insights.",
      points: [
        {
          icon: "Heart",
          title: "One app for the horse's entire life",
          body: "From foal to sport horse, broodmare, or retired horse. The record grows with your horse — nothing gets lost along the way.",
        },
        {
          icon: "Sparkles",
          title: "Not just data, but patterns too",
          body: "EquiCoach combines development, recurring issues, training, and nutrition — so you spot signals early, not as isolated alerts.",
        },
        {
          icon: "Share2",
          title: "Built for collaboration",
          body: "Owner, yard manager, trainer, farrier, and other professionals all work from the same horse record — with permissions that match their role.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Niche · breeding",
      title: "Horse management for breeding operations.",
      lead: "Many competitors mention breeding in a single line. EquiSight built a complete breeding module — because the breeder is rarely the target user of a general app, yet needs planning more than anyone else.",
      items: [
        "Track the mare cycle daily",
        "Insemination date + stallion details",
        "Pregnancy check with scans",
        "Expected foaling date + alerts",
        "Foal development per month",
        "Pedigree and bloodlines",
        "Notes per mare",
        "Overview of all pregnant mares",
      ],
      ctaLabel: "View the breeding module",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Niche · stable & riding school",
      title: "Horse management for multiple horses and livery yards.",
      lead: "With multiple horses, it's less about data and more about communication. Every owner has their own wishes, routines, feeding arrangements, and medical considerations. Every staff member needs to access that information without having to search.",
      cards: [
        {
          t: "Horses per owner",
          d: "Each owner sees only their own horse(s).",
        },
        {
          t: "Care instructions",
          d: "Visible per horse for stable staff.",
        },
        {
          t: "Shared calendar",
          d: "Farrier, vet, and competitions in one view.",
        },
        {
          t: "Task list",
          d: "Assign to staff members, with confirmation.",
        },
        {
          t: "Owner access",
          d: "Clients see their horse in their own app.",
        },
        {
          t: "Emergency contacts",
          d: "Always easy to find in stressful situations.",
        },
      ],
      ctaLabel: "View the yard module",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "From WhatsApp, Excel, and whiteboards to EquiSight.",
      lead: "Concretely: this is how your daily horse management changes.",
      rows: [
        {
          before: "WhatsApp group chats",
          after: "Structured notes per horse",
        },
        {
          before: "Excel spreadsheets",
          after: "Live horse record with history",
        },
        {
          before: "Whiteboard in the stable",
          after: "Shared planning on your phone",
        },
        {
          before: "Loose photos on your camera",
          after: "Media linked to your horse",
        },
        {
          before: "Verbal agreements",
          after: "Tasks and reminders with confirmation",
        },
        {
          before: "Paper passport gone missing",
          after: "Documents always at hand",
        },
      ],
    },
    helper: {
      title: "Which horse management app suits you?",
      lead: "Answer these 5 questions and get an honest recommendation — even if that recommendation isn't always EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Do you have one horse or multiple horses?",
          options: [
            {
              label: "One horse",
              score: 1,
            },
            {
              label: "2–5 horses",
              score: 2,
            },
            {
              label: "More than 5 horses",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Do you manage horses belonging to clients or third parties?",
          options: [
            {
              label: "No, only my own horses",
              score: 0,
            },
            {
              label: "Sometimes — for family or friends",
              score: 1,
            },
            {
              label: "Yes, professionally (stable / riding school)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Do you want to track breeding and pregnancy?",
          options: [
            {
              label: "Not relevant",
              score: 0,
            },
            {
              label: "Sometimes — occasional breeding",
              score: 1,
            },
            {
              label: "Yes, I am (or will become) a breeder",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Do you work together with a trainer, carer, or professional?",
          options: [
            {
              label: "No, I do everything myself",
              score: 0,
            },
            {
              label: "Yes, with 1 person",
              score: 1,
            },
            {
              label: "Yes, with multiple people",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Do you want to just record, or also gain insights?",
          options: [
            {
              label: "Just record",
              score: 1,
            },
            {
              label: "Record + planning",
              score: 2,
            },
            {
              label: "Record + planning + insights",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "A simple logbook is enough — and grows with you.",
          body: "For one horse without shared care, any horse management app will do. EquiSight starts free with 1 horse, so there's no risk. If you later want to add more horses, a trainer, or breeding, everything is already built in.",
          cta: "Start free with 1 horse",
        },
        mid: {
          title: "EquiSight fits your situation well.",
          body: "You have multiple needs — multiple horses, collaboration, or insights. Most competitors cover 1–2 modules; EquiSight combines them in one app, without needing to connect separate tools.",
          cta: "See what EquiSight can do",
        },
        high: {
          title: "EquiSight is the most logical choice.",
          body: "Your situation combines multiple horses, collaboration, breeding, and/or insights. This is precisely where EquiSight makes the difference — no fragmented tools, just one horse record for everything and everyone around your horse.",
          cta: "Start free with EquiSight",
        },
      },
    },
    faqTitle: "Frequently asked questions about horse management apps",
    faq: [
      {
        q: "What is the best horse management app?",
        a: "The best horse management app depends on your situation. For a simple logbook, several apps will do the job. If you want to combine health, training, nutrition, documents, breeding, planning, and collaboration, EquiSight is built as a complete solution where everything comes together in one record.",
      },
      {
        q: "Can I manage multiple horses in one app?",
        a: "Yes. A good horse management app must support multiple horses, including owners, carers, routines, documents, appointments, and reminders per horse. EquiSight was designed with this in mind from the very first line of code — horses are individual records, not rows in a list.",
      },
      {
        q: "Is EquiSight suitable for breeding operations?",
        a: "Yes. EquiSight can be set up with breeding features such as mare cycle tracking, insemination date, pregnancy checks, stallion details, pedigree, expected foaling date, and foal development. This is precisely the area where most competing apps offer little to no support.",
      },
      {
        q: "Can I share information with my trainer or farrier?",
        a: "Yes. EquiSight is designed so that relevant information can be shared securely with people involved with the horse — trainer, farrier, dentist, vet, physio, carer, or owner. Each person only receives the permissions needed for their role.",
      },
      {
        q: "Why not just use WhatsApp or Excel?",
        a: "WhatsApp and Excel work fine as long as things stay simple. Once you have multiple horses, appointments, documents, treatments, owners, or breeding data, errors creep in: information becomes scattered, searching takes time, and verbal agreements disappear. A horse management app brings everything together per horse, with automatic reminders.",
      },
      {
        q: "What does EquiSight cost?",
        a: "You can start free with 1 horse. If you want to manage multiple horses, activate breeding features, or give professionals access, affordable Premium plans are available. Check the current options on the pricing page.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Breeding software horse: complete comparison 2026",
      description: "Compare breeding software for horses: mare cycle, pregnancy, stallion selection and foals. Discover why EquiSight is the complete breeding app.",
      keywords: [
        "breeding software horse",
        "mare cycle app",
        "mare pregnancy app",
        "foal registration app",
        "studbook app horse",
        "breeding planning horse",
        "stallion selection app",
      ],
    },
    hero: {
      eyebrow: "Decision guide · breeding software",
      breadcrumbLabel: "Breeding software",
      title: "Breeding software for horses: the complete comparison for 2026.",
      intro: "A broodmare deserves more than a generic horse management app. Compare the breeding features of the most well-known tools, discover what really matters, and make an informed choice for the software that fits your stud farm — large or small.",
      pills: [
        {
          icon: "Baby",
          label: "Mare cycle",
        },
        {
          icon: "Heart",
          label: "Pregnancy check",
        },
        {
          icon: "Sparkles",
          label: "Foal development",
        },
        {
          icon: "FileText",
          label: "Studbook",
        },
      ],
      ctas: [
        {
          label: "Start free with the breeding module",
          href: "#start",
          primary: true,
        },
        {
          label: "Go to comparison table",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Why a regular horse management app isn't enough for breeding.",
      lead: "Most equestrian apps are designed for a single sport or leisure horse. Breeding has a completely different rhythm: heat cycles, insemination, pregnancy checks, ultrasounds, foal calendar, pedigree and sales. One Excel spreadsheet falls apart after 2 seasons — and with multiple mares you quickly lose track.",
      items: [
        "When exactly was Bonita's last cycle again?",
        "Which stallion is planned for covering next season?",
        "Has the 21-day ultrasound been scheduled yet?",
        "Which foals from 2024 have already been sold?",
        "Where is the pedigree chart going back to the maternal grandfather?",
        "Where are the DNA samples and passport details?",
      ],
    },
    what: {
      title: "What is breeding software for horses?",
      lead: "Breeding software is a dedicated file per mare and stallion, combined with a breeding-year calendar, pregnancy planning, foal registration and pedigree display. Not a general horse logbook, but a tool that understands the breeding cycle: from first heat to weaning.",
      targetGroupsTitle: "What type of breeder is breeding software intended for?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobby breeder (1–3 mares)",
          body: "One or two coverings per year — clear overview without Excel acrobatics.",
        },
        {
          icon: "Building2",
          title: "Small stud farm (4–10 mares)",
          body: "A breeding-year plan with cycle, insemination, pregnancy checks and foal file.",
        },
        {
          icon: "Users",
          title: "Professional stud farm (10+)",
          body: "Multiple staff members, stallion selection per mare, sales and marketing.",
        },
        {
          icon: "Target",
          title: "Stallion owner",
          body: "Order history, semen statistics and schedule per stallion.",
        },
        {
          icon: "Heart",
          title: "Embryo transfer",
          body: "Donor + recipient mare as linked files, ET calendar.",
        },
        {
          icon: "ClipboardList",
          title: "Studbook registration",
          body: "DNA samples, passport documents and pedigree data.",
        },
      ],
    },
    criteria: {
      title: "What should good breeding software meet?",
      lead: "Not every 'breeding feature' in a horse app is the same. Five core areas where breeders lose a lot of time — and where software truly makes a difference.",
      items: [
        {
          icon: "Calendar",
          title: "Mare cycle & heat detection",
          body: "Daily log, predictive ovulation, cycle roll-over and automatic reminders.",
        },
        {
          icon: "Heart",
          title: "Insemination & pregnancy check",
          body: "Covering and insemination dates, stallion details, 14-day ultrasound, 21-day ultrasound, 60-day ultrasound and sex determination.",
        },
        {
          icon: "Baby",
          title: "Foal development",
          body: "Birth data, weight chart, deworming schedule, weaning moment, passport registration.",
        },
        {
          icon: "FileText",
          title: "Pedigree & paperwork",
          body: "Pedigree view up to 4–5 generations, DNA, passport numbers and studbook status.",
        },
        {
          icon: "Target",
          title: "Stallion selection & matching",
          body: "Filter by discipline, bloodlines, stallion details and historical success — not just what a stallion owner pushes.",
        },
        {
          icon: "Share2",
          title: "Collaboration with vet/inseminator",
          body: "Ultrasounds, samples and statuses shared directly with the practice working on your mares.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs other breeding software.",
      lead: "The Dutch SERP for breeding software often shows generic horse apps that mention breeding in a single sentence. We honestly compare which tools truly have a complete breeding workflow.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Start for free",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Log mare cycle",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Insemination date + stallion",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ultrasounds & pregnancy check",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Expected foaling date",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Foal file (weight/growth)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Pedigree up to 4–5 generations",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNA & passport registration",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Stallion selection / matching",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embryo transfer",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Multi-mare overview",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobile (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Share with vet",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrated with general file",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Sales & marketing of foals",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Comparison based on publicly available features in January 2026. EquineGenie is strong in breeding, but less so in mobile + general horse management. EquiSight combines both.",
    },
    why: {
      title: "Why EquiSight serves breeders differently.",
      lead: "Many breeders work with separate breeding software and a separate horse management app. EquiSight combines both — without switching between apps or entering data twice.",
      points: [
        {
          icon: "Heart",
          title: "Broodmare is still just a horse",
          body: "The broodmare has a breeding year and a regular horse file — health, vaccinations, farrier. One app, all modules.",
        },
        {
          icon: "Sparkles",
          title: "Predictive instead of reactive",
          body: "Cycle prediction, pregnancy milestone reminders and foal calendar — automatically based on your data.",
        },
        {
          icon: "Share2",
          title: "Everyone involved in breeding",
          body: "Inseminator, stallion owner, vet, buyer, studbook — all with access at the right permission level.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Per discipline · cycle to weaning",
      title: "What a breeding file in EquiSight contains.",
      lead: "Each mare gets a complete breeding file, linked to her regular horse file.",
      items: [
        "Daily cycle log with prediction",
        "Insemination/covering + stallion details",
        "Ultrasound timeline (14/21/60 days + sex)",
        "Pregnancy milestones with automatic reminders",
        "Expected foaling date and preparation",
        "Foal file from birth",
        "Pedigree up to grandparents with click navigation",
        "DNA sample, passport, studbook status",
        "Sales pipeline with interested parties",
        "Stallion selection history per mare",
      ],
      ctaLabel: "View the breeding module",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "For the entire stud farm",
      title: "Overview for multiple mares and stallions.",
      lead: "When you breed more than 2–3 mares, having an overview of all cycles and pregnancies becomes crucial.",
      cards: [
        {
          t: "Cycle dashboard",
          d: "All mares side by side, with cycle stage and next action.",
        },
        {
          t: "Pregnancy pipeline",
          d: "Which mares are at which pregnancy milestone?",
        },
        {
          t: "Foal calendar",
          d: "Expected births per month, with logistics planned accordingly.",
        },
        {
          t: "Stallion portfolio",
          d: "Own stallions or regular inseminators with order history.",
        },
        {
          t: "Pedigree chart",
          d: "Ancestor analysis across multiple generations and bloodlines.",
        },
        {
          t: "Sales dashboard",
          d: "Which foals are sold, reserved or still available.",
        },
      ],
    },
    beforeAfter: {
      title: "From Excel + calendar to EquiSight breeding.",
      lead: "Concretely: this is how your breeding season changes.",
      rows: [
        {
          before: "Cycle in a loose note",
          after: "Daily log with prediction",
        },
        {
          before: "Ultrasounds via WhatsApp to inseminator",
          after: "Shared file with photos",
        },
        {
          before: "Pregnancy date in calendar",
          after: "Automatic milestone reminders",
        },
        {
          before: "Foal passport in a drawer",
          after: "Document linked to foal profile",
        },
        {
          before: "Pedigree on paper",
          after: "Clickable pedigree up to 4–5 generations",
        },
        {
          before: "Sales listing on Marktplaats",
          after: "Sales pipeline with interest list",
        },
      ],
    },
    helper: {
      title: "Which breeding software suits you?",
      lead: "5 questions to find out whether you need a complete breeding app or whether a hobby tool will do.",
      questions: [
        {
          id: "mares",
          q: "How many broodmares do you manage?",
          options: [
            {
              label: "1 mare",
              score: 1,
            },
            {
              label: "2–5 mares",
              score: 2,
            },
            {
              label: "More than 5 mares",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "How often do you breed per year?",
          options: [
            {
              label: "Occasionally (every few years)",
              score: 0,
            },
            {
              label: "1–2 coverings every year",
              score: 2,
            },
            {
              label: "3+ coverings every year",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "How do you inseminate/cover?",
          options: [
            {
              label: "Natural covering",
              score: 1,
            },
            {
              label: "AI fresh/chilled semen",
              score: 2,
            },
            {
              label: "ET or frozen semen",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Do you collaborate with a vet/inseminator?",
          options: [
            {
              label: "One regular person",
              score: 1,
            },
            {
              label: "Multiple practices",
              score: 2,
            },
            {
              label: "International network",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "What do you currently track?",
          options: [
            {
              label: "Excel or paper",
              score: 1,
            },
            {
              label: "General horse management app",
              score: 2,
            },
            {
              label: "Nothing structured",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "A hobby tool or Excel is sufficient — but EquiSight is still handy.",
          body: "For 1 mare with natural covering every few years, an extensive breeding module is overkill. EquiSight starts free and you only activate the breeding module for the year you breed — no upgrade obligation.",
          cta: "Start free",
        },
        mid: {
          title: "EquiSight breeding is the right tool.",
          body: "You have multiple mares or multiple breeding methods — general horse apps aren't built for that. EquiSight combines breeding + general care, so you don't need to switch between two tools.",
          cta: "View the breeding module",
        },
        high: {
          title: "EquiSight is built for your stud farm.",
          body: "Multiple mares, ET or frozen semen, international team — most tools fall short here. EquiSight scales up to stud farm level without stacking extra licences.",
          cta: "Talk to us about a Stud Farm plan",
        },
      },
    },
    faqTitle: "Frequently asked questions about breeding software",
    faq: [
      {
        q: "What is the best breeding software for horses?",
        a: "For 1 mare without a complex breeding method, many tools will do. From 2–3 mares onwards, use of AI or ET, or collaboration with a vet and studbook, a complete breeding module becomes crucial. EquiSight combines breeding with general horse management in one app, so you don't need to switch.",
      },
      {
        q: "Which breeding features do I really need?",
        a: "At a minimum: cycle log, insemination/covering data, pregnancy milestone tracking, and foal file. Optional but powerful: pedigree view, stallion selection archive, DNA/passport and sales pipeline.",
      },
      {
        q: "Can EquiSight predict a mare's cycle?",
        a: "Yes. EquiSight uses previous cycle data to show the predicted ovulation, so you can plan insemination or covering at exactly the right moment — without daily guesswork.",
      },
      {
        q: "Does EquiSight also work for embryo transfer?",
        a: "Yes. Donor and recipient mare get linked files, an ET calendar and shared milestones with the practice. This way you never lose track of the timeline in the complex ET workflow.",
      },
      {
        q: "Can I import my existing breeding data?",
        a: "You can enter cycle, covering and foal data manually or in bulk via CSV. For active breeding operations with multiple seasons of data, we help with a one-time migration.",
      },
      {
        q: "How do I share a file with my vet or inseminator?",
        a: "Each person gets access with a role: vet, inseminator, stallion owner or studbook official. Everyone only sees the information relevant to their role — no full access required.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Riding school software: complete comparison & selection guide 2026",
      description: "Compare riding school software for lessons, riders, horses and administration. Discover which app suits your riding school or livery yard.",
      keywords: [
        "riding school software",
        "stable management app",
        "riding school administration software",
        "lesson planning riding school",
        "livery yard software",
        "rider administration",
        "horse administration riding school",
      ],
    },
    hero: {
      eyebrow: "Selection guide · riding school software",
      breadcrumbLabel: "Riding school software",
      title: "Riding school software: the complete selection guide for riding schools and livery yards.",
      intro: "Lesson planning, rider administration, horse management, invoicing and communication — good riding school software brings it all together. Compare the best-known options and discover which one suits your stable or riding school.",
      pills: [
        {
          icon: "Calendar",
          label: "Lesson planning",
        },
        {
          icon: "Users",
          label: "Riders & clients",
        },
        {
          icon: "Heart",
          label: "Horse care",
        },
        {
          icon: "CreditCard",
          label: "Invoicing",
        },
      ],
      ctas: [
        {
          label: "Request a demo",
          href: "#start",
          primary: true,
        },
        {
          label: "Go to comparison table",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Why scattered tools slow a riding school down.",
      lead: "Most riding schools run on a patchwork: lesson planning on a whiteboard, rider registration in Excel, invoicing in a separate tool, horse care in WhatsApp and owner contact via personal messages. During a busy week this leads to double bookings, forgotten invoices or horses with no clear rider assignment.",
      items: [
        "Who is currently in a lesson with Jasmine?",
        "Which rider hasn't paid for March yet?",
        "Which horse can't be used this week?",
        "Who are the emergency contacts for the students?",
        "Has the owner of Stardust already received the farrier invoice?",
        "Which horse is in which stable?",
      ],
    },
    what: {
      title: "What is riding school software?",
      lead: "Riding school software combines lesson planning, rider administration, horse management, invoicing and communication in one tool. No Excel acrobatics or WhatsApp spaghetti — just one place where the riding school operates and owners/riders can keep track.",
      targetGroupsTitle: "What type of business is riding school software designed for?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Small riding school (1-15 horses)",
          body: "Primarily lesson planning and payments — administration without the headache.",
        },
        {
          icon: "Users",
          title: "Medium riding school (15-40 horses)",
          body: "Multiple instructors, lesson planning + horse schedule + rider administration.",
        },
        {
          icon: "ClipboardList",
          title: "Large riding and livery yard (40+)",
          body: "Full operations including invoicing, feed and farrier planning.",
        },
        {
          icon: "Heart",
          title: "Livery yard",
          body: "Owner portal, individual care instructions, shared calendar.",
        },
        {
          icon: "Target",
          title: "Show jumping training yard",
          body: "Competition planning, training per horse, client communication.",
        },
        {
          icon: "FileText",
          title: "Equestrian entrepreneurs",
          body: "Mix of lessons + livery + clinics + trading — all from one system.",
        },
      ],
    },
    criteria: {
      title: "What should good riding school software deliver?",
      lead: "A beautiful app means nothing if your staff won't use it. Five practical criteria that make the difference between success and frustration.",
      items: [
        {
          icon: "Calendar",
          title: "Multi-level lesson planning",
          body: "Beginner/advanced, dressage/jumping, horse assignments and instructor calendars — all visible side by side.",
        },
        {
          icon: "Users",
          title: "Rider administration",
          body: "Profiles, level, subscription, lesson cards and family member links for junior riders.",
        },
        {
          icon: "Heart",
          title: "Horse schedule",
          body: "How often each horse is used, with rest, injury and recovery periods.",
        },
        {
          icon: "CreditCard",
          title: "Invoicing & subscriptions",
          body: "Monthly subscriptions, lesson cards, individual lessons and automatic direct debit.",
        },
        {
          icon: "Share2",
          title: "Owner portal (livery yard)",
          body: "Owners see their horse in their own app — schedule, costs, farrier and notes without phone calls.",
        },
        {
          icon: "Bell",
          title: "Communication & reminders",
          body: "Automatic lesson reminders, payment notifications, farrier announcements — no messaging apps required.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs other riding school software.",
      lead: "Many riding school tools are strong in lesson planning or invoicing, but rarely in horse care and owner communication combined. We put them side by side honestly.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Free to start / trial period",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Lesson planning",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Multiple instructors",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Rider administration",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Horse schedule",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Horse care (vaccination/farrier)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Lesson card / subscription",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Online payments",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automatic invoicing",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Owner portal (livery)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Farrier/vet integration",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/SMS reminders",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobile (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Competition planning",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Suitable for livery yard",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Comparison based on publicly available features as of January 2026. Stalmanager is strong in administration; EquiSight distinguishes itself in livery yard workflow + horse care + owner portal.",
    },
    why: {
      title: "Why EquiSight is different for riding schools and livery yards.",
      lead: "EquiSight goes beyond a lesson planner. We see a riding school as a complete operation: horses, people, communication and finances — all interdependent.",
      points: [
        {
          icon: "Heart",
          title: "Horse at the centre, not the calendar",
          body: "Every horse has its own record. Lesson use, health, farrier visits and competitions in one timeline — not 3 separate tools.",
        },
        {
          icon: "Share2",
          title: "Owners stay informed without phone calls",
          body: "Livery yard owners have their own view: costs, schedule, photos and notes — saving 5-10 phone calls per week.",
        },
        {
          icon: "Bell",
          title: "Automatic communication",
          body: "Lesson reminder, vaccination reminder, invoice — automatic, via app/email/SMS. No more broadcast WhatsApp messages.",
        },
      ],
    },
    nicheB: {
      eyebrow: "For the livery yard",
      title: "What a livery yard gets from EquiSight.",
      lead: "Livery yards have unique challenges that standard riding school software doesn't solve.",
      cards: [
        {
          t: "Owner portal",
          d: "Each owner only sees their own horse(s), schedule and costs.",
        },
        {
          t: "Care instructions per horse",
          d: "Feed, roughage, supplements, rug schedule — visible to the yard team.",
        },
        {
          t: "Shared calendar",
          d: "Farrier, vet and owner visits in one view.",
        },
        {
          t: "Usage costs per horse",
          d: "Bedding, feed and concentrates charged through per owner.",
        },
        {
          t: "Emergency contacts per horse",
          d: "Owner, vet and farrier always findable for the yard.",
        },
        {
          t: "Turnout management",
          d: "Which horses are on pasture, resting or in rehabilitation?",
        },
      ],
    },
    beforeAfter: {
      title: "From whiteboard + Excel to EquiSight.",
      lead: "Concretely: this is how a working week at the riding school changes.",
      rows: [
        {
          before: "Whiteboard with the lesson schedule",
          after: "Live planning per instructor",
        },
        {
          before: "Excel with riders + lesson notes",
          after: "Client CRM with lesson history",
        },
        {
          before: "WhatsApp to owners",
          after: "Owner portal for their horse",
        },
        {
          before: "Monthly direct debit done manually",
          after: "Automatic invoicing + iDEAL",
        },
        {
          before: "Horse care on a paper noticeboard",
          after: "Care instructions per horse, shared",
        },
        {
          before: "Verbal farrier appointment",
          after: "Farrier planning with confirmations",
        },
      ],
    },
    helper: {
      title: "Which riding school software suits you?",
      lead: "5 questions to see whether EquiSight is the right platform for your riding school or livery yard.",
      questions: [
        {
          id: "size",
          q: "How many horses do you have in your business?",
          options: [
            {
              label: "Fewer than 10",
              score: 1,
            },
            {
              label: "10-30",
              score: 2,
            },
            {
              label: "More than 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "What is your main activity?",
          options: [
            {
              label: "Primarily giving lessons",
              score: 1,
            },
            {
              label: "Livery yard (horses on livery)",
              score: 3,
            },
            {
              label: "Mix of lessons + livery",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "How many instructors do you work with?",
          options: [
            {
              label: "Just myself",
              score: 1,
            },
            {
              label: "2-3 instructors",
              score: 2,
            },
            {
              label: "4 or more",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "How do you handle your invoicing now?",
          options: [
            {
              label: "Manually (Word/Excel)",
              score: 3,
            },
            {
              label: "Separate accounting software",
              score: 2,
            },
            {
              label: "Integrated into lesson tool",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "How do you communicate with owners?",
          options: [
            {
              label: "In person / WhatsApp",
              score: 3,
            },
            {
              label: "Email + WhatsApp",
              score: 2,
            },
            {
              label: "Owner portal in the tool",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "A lightweight tool or Excel will do for now — but EquiSight scales with you.",
          body: "For a small lesson business with one instructor and little livery, a comprehensive package isn't immediately necessary. EquiSight starts free and grows with your riding school — no painful migration a few years down the line.",
          cta: "Start for free",
        },
        mid: {
          title: "EquiSight is a logical upgrade for your riding school.",
          body: "Multiple instructors, a mix of lessons and livery, or invoicing that currently stands alone — EquiSight bundles that into one workflow. The owner portal in particular saves a lot of ad-hoc communication.",
          cta: "Request a demo",
        },
        high: {
          title: "EquiSight is built for your scale.",
          body: "Livery yard + lessons + multiple instructors is exactly where EquiSight sets itself apart from classic riding school tools. The owner portal and horse care integration save hours of administration and communication every week.",
          cta: "Schedule a demo for your yard",
        },
      },
    },
    faqTitle: "Frequently asked questions about riding school software",
    faq: [
      {
        q: "What is the best riding school software?",
        a: "For pure lesson planning there are several good options. Once you need a livery yard, multiple instructors or horse care tracking, EquiSight becomes the complete solution — no tool juggling, everything in one place.",
      },
      {
        q: "Can I import existing clients and lessons?",
        a: "Yes. Client data and lesson schedules can be imported via CSV. We help active riding schools with a one-time migration so you don't have to enter 200 riders manually.",
      },
      {
        q: "Does it also work for a livery yard without lessons?",
        a: "Yes. Livery yard mode disables lessons and focuses on the owner portal, feed/care, farrier planning and costs charged through per horse.",
      },
      {
        q: "Can riders register and pay by themselves?",
        a: "Yes. Riders can use their own account to see which lessons are available, sign up, pay lesson fees with iDEAL and purchase lesson cards.",
      },
      {
        q: "What about the privacy of horse and owner data?",
        a: "Every person has a role (owner, rider, instructor, staff member). Each role only sees what it needs. Owners only see their own horse, riders only their own lessons.",
      },
      {
        q: "Can EquiSight connect to my accounting software?",
        a: "Yes, integrations with Exact, Moneybird and e-Boekhouden are available. Invoices then flow automatically into your accounting system.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Trainer app horse: comparison & decision guide for coaches 2026",
      description: "Compare trainer apps for horse and rider: training log, video, goals, protocol analysis and client management. Find the right tool for coaches.",
      keywords: [
        "trainer app horse",
        "instructor app",
        "horse training app",
        "rider coaching app",
        "training diary horse",
        "dressage protocol analysis",
        "horse trainer software",
      ],
    },
    hero: {
      eyebrow: "Decision guide · trainer software",
      breadcrumbLabel: "Trainer app",
      title: "Trainer app horse: complete decision guide for instructors and coaches.",
      intro: "A trainer or instructor juggles combinations, lessons, videos, goals and competitions. Compare the best trainer apps for horse people and choose the platform that keeps growing with your coaching in 2026.",
      pills: [
        {
          icon: "Target",
          label: "Goals & planning",
        },
        {
          icon: "Video",
          label: "Video analysis",
        },
        {
          icon: "TrendingUp",
          label: "Progress",
        },
        {
          icon: "Users",
          label: "Clients/combinations",
        },
      ],
      ctas: [
        {
          label: "Start free as a trainer",
          href: "#start",
          primary: true,
        },
        {
          label: "Go to comparison table",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Why WhatsApp coaching gets in trainers' way.",
      lead: "Most trainers work with separate tools: WhatsApp for communication, a notebook for lessons, YouTube or WeTransfer for videos and Excel for competition results. With 5 riders it works. With 20 riders information gets lost, you forget goals and lose track of individual progress.",
      items: [
        "Where is Anouk's goal for this season?",
        "Which video did I send to Bram last month?",
        "Has Lara seen the protocol analysis of her last competition?",
        "Which combination trains how many times per week?",
        "Has Stardust's owner read my training instruction?",
        "When was the last time I gave feedback on inconsistent impulsion?",
      ],
    },
    what: {
      title: "What is a trainer app for horse and rider?",
      lead: "A trainer app combines a coaching CRM (combinations, lessons, goals), a training log per horse, video feedback, competition planning and protocol analysis. No more separate WhatsApp/YouTube/Excel, but one platform where trainer and rider work together.",
      targetGroupsTitle: "What type of trainer is this intended for?",
      targetGroups: [
        {
          icon: "Target",
          title: "Dressage instructor",
          body: "Scan protocols, link judge comments to training goals, track progress.",
        },
        {
          icon: "Activity",
          title: "Show jumping trainer",
          body: "Course planning, round feedback, fence height management per horse.",
        },
        {
          icon: "Award",
          title: "Eventing coach",
          body: "Three disciplines, three plans — all visible side by side.",
        },
        {
          icon: "TrendingUp",
          title: "Performance coach (sport)",
          body: "EPI tracking, competitions, goals — for elite athletes and their teams.",
        },
        {
          icon: "Users",
          title: "Riding school instructor",
          body: "Group lessons + individual coaching in one app.",
        },
        {
          icon: "Heart",
          title: "Recreational coach",
          body: "Equine therapy, beginners, owners with one horse.",
        },
      ],
    },
    criteria: {
      title: "What should a good trainer app offer?",
      lead: "Training is people work, but the right tool makes you 30-50% more efficient and helps riders improve between lessons too.",
      items: [
        {
          icon: "Users",
          title: "Combinations management",
          body: "Horse + rider as one unit, with level, goals, progress and history.",
        },
        {
          icon: "ClipboardList",
          title: "Lesson notes & goals",
          body: "A note with focus points per lesson, linked to longer-term goals.",
        },
        {
          icon: "Video",
          title: "Video feedback",
          body: "Upload video, tag moments, add spoken or written feedback.",
        },
        {
          icon: "Target",
          title: "Competition & protocol analysis",
          body: "Scan protocols (KNHS/FEI), see scores per element, judge comments and trends.",
        },
        {
          icon: "Calendar",
          title: "Planning & lesson cards",
          body: "Calendar, payments, subscriptions and automatic reminders.",
        },
        {
          icon: "Share2",
          title: "Communication to rider",
          body: "Rider sees their own page with lessons, videos, goals and feedback.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs other trainer apps.",
      lead: "Some trainer tools focus on replacing WhatsApp, others on protocol analysis. EquiSight combines both with a real horse file — so the rider also improves between lessons.",
      competitors: [
        "EquiSight",
        "Coach Apps (algemeen)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Start for free",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Combinations management",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Lesson notes & feedback",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Long-term goals",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Video upload + feedback",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "KNHS/FEI protocol scanning",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Performance Index)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Competition calendar",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Rider portal",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Lesson card / subscription",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Online payments",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integrated horse file",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Farrier/vet visible",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "For instructor AND rider",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Multi-horse per rider",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Comparison based on publicly available features in January 2026. EquiSight is unique in protocol analysis + EPI and combines this with general horse management.",
    },
    why: {
      title: "Why EquiSight offers a different trainer experience.",
      lead: "Most trainer tools stop where the lesson ends. EquiSight keeps going — in the horse file, in the competition analysis, in collaboration with the vet and owner.",
      points: [
        {
          icon: "TrendingUp",
          title: "Protocol scan → training goal",
          body: "Scan a KNHS protocol and immediately see which elements need attention. Goals surface automatically.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach sharpens your eye",
          body: "Data from multiple lessons, competitions and protocols reveals patterns you can't keep track of in your head.",
        },
        {
          icon: "Share2",
          title: "Integrated with the horse",
          body: "Trainer sees vaccination, farrier and injury history of the horse — no planning training sessions during recovery.",
        },
      ],
    },
    nicheA: {
      eyebrow: "For dressage and show jumping",
      title: "What a coaching file in EquiSight contains.",
      lead: "Per combination you get a coaching stream that keeps everything together — no more losing things in WhatsApp.",
      items: [
        "Lesson notes with focus points per session",
        "Long-term goals + milestones",
        "Video upload with timecode comments",
        "KNHS/FEI protocol scan with scores",
        "Judge comments linked to training",
        "Competition results and EPI trend",
        "Client contact and lesson history",
        "Lesson card / subscription / invoices",
        "Progress chart per discipline",
        "Shared access with horse owner",
      ],
      ctaLabel: "View the trainer module",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "From WhatsApp + YouTube to EquiSight Trainer.",
      lead: "Concretely: this is how your coaching workflow changes.",
      rows: [
        {
          before: "WhatsApp with loose video links",
          after: "Video with timecode feedback in file",
        },
        {
          before: "Notebook per rider",
          after: "Coaching log with goals + history",
        },
        {
          before: "Excel with competition scores",
          after: "EPI chart + protocol analysis",
        },
        {
          before: "Verbal goals",
          after: "Milestones with progress indicator",
        },
        {
          before: "Separate invoicing tool",
          after: "Lessons + iDEAL + subscription in app",
        },
        {
          before: "Email to owner about progress",
          after: "Owner follows along in their own view",
        },
      ],
    },
    helper: {
      title: "Which trainer app suits you?",
      lead: "5 questions to see if a specialised coaching tool adds value to your practice.",
      questions: [
        {
          id: "clients",
          q: "How many active combinations do you coach?",
          options: [
            {
              label: "Fewer than 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "More than 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "What is your main discipline?",
          options: [
            {
              label: "Dressage",
              score: 3,
            },
            {
              label: "Show jumping",
              score: 2,
            },
            {
              label: "Recreational / varied",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Do you use video in coaching?",
          options: [
            {
              label: "Rarely",
              score: 0,
            },
            {
              label: "Sometimes (manually)",
              score: 2,
            },
            {
              label: "Often — systematically",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Do you coach competition riders?",
          options: [
            {
              label: "No, recreational",
              score: 0,
            },
            {
              label: "Occasional competitions",
              score: 2,
            },
            {
              label: "Frequently — entry cards are central",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Do you want to measure your coaching?",
          options: [
            {
              label: "No, intuition is enough",
              score: 0,
            },
            {
              label: "Yes, but no time",
              score: 2,
            },
            {
              label: "Yes — data-driven coaching",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "A simple tool or even WhatsApp is sufficient — for now.",
          body: "For fewer than 5 riders without much video or competition work, a coaching app is overkill. EquiSight starts free, so you can try it out when your practice grows.",
          cta: "Start free",
        },
        mid: {
          title: "EquiSight Trainer makes you structurally more efficient.",
          body: "With 5-15 combinations you lose hours every month to WhatsApp and loose videos. EquiSight bundles everything, scans protocols automatically and ensures riders can always look back at their feedback.",
          cta: "Try Trainer module",
        },
        high: {
          title: "EquiSight is built for your coaching scale.",
          body: "Many riders, video, competitions and data-driven coaching: this is exactly where EquiSight stands out. EPI + protocol scan + horse file gives you an edge that competitors don't have.",
          cta: "Schedule a demo for your coaching practice",
        },
      },
    },
    faqTitle: "Frequently asked questions about trainer apps",
    faq: [
      {
        q: "What is the best trainer app for horse and rider?",
        a: "For pure communication many tools suffice (even WhatsApp). For goals, video analysis, protocol scanning, competition tracking and client management in one tool, EquiSight is the most complete solution — especially because it also tracks the horse itself, not just the combination.",
      },
      {
        q: "Can EquiSight automatically read competition protocols?",
        a: "Yes. Upload a KNHS or FEI protocol and EquiSight extracts the scores per element, judge comments and links them to the combination. You can see trends across multiple competitions.",
      },
      {
        q: "What is the EPI (Equestrian Performance Index)?",
        a: "EPI is an EquiSight score that converts multiple competition results into a comparable performance index. This lets you see real progress across different classes and judges.",
      },
      {
        q: "Can riders book and pay for my lessons themselves?",
        a: "Yes. Riders log in, see available lesson times, purchase lesson cards and pay via iDEAL. You decide what you want to offer and approve accordingly.",
      },
      {
        q: "Does it also work for an instructor who works around a riding school?",
        a: "Yes. You can work as a freelance trainer with your own clients without linking a riding school account. Clients pay you directly.",
      },
      {
        q: "Can I migrate existing videos and notes?",
        a: "Videos can be uploaded per combination or via a batch upload tool. Notes can be imported via CSV. We assist active trainers with a one-time migration.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Guides & decision tools for horse management software | EquiSight",
      description: "All EquiSight guides in one place: horse management, breeding, riding school and trainer software comparisons plus decision tools for 2026.",
      keywords: [
        "horse software guides",
        "horse management decision tool",
        "breeding software comparison",
        "riding school software guide",
        "trainer app comparison",
      ],
    },
    hub: {
      eyebrow: "Hub · guides",
      breadcrumbLabel: "Guides",
      title: "Four complete guides to help you choose the right horse software.",
      intro: "An in-depth decision tool for every audience: comparison tables, criteria, examples and an interactive quiz. Click through to the guide that matches your situation, or explore the supporting articles under each cluster first.",
      stats: {
        guides: "4 decision tools",
        articles: "15 in-depth articles",
        fair: "Honest comparison",
      },
      readMoreCta: "Read the complete guide",
      relatedHeading: "In-depth articles",
      articlesCountSingular: "{{count}} in-depth article",
      articlesCountPlural: "{{count}} in-depth articles",
      articlesCountAria: "Number of cluster articles",
      lastUpdatedPrefix: "Updated",
      lastUpdatedAria: "Date of last update for this cluster",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Horse management app decision tool",
        blurb: "Compare the most popular horse management apps and discover which one suits owners, stables or breeding operations. Includes an honest comparison table and a 5-question decision tool.",
        audience: "For owners, stable managers and all horse people looking for clarity.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Breeding software comparison",
        blurb: "From mare cycles to foal development: see which breeding software truly works for your number of mares, breeding method and studbook requirements.",
        audience: "For (hobby) breeders, stud farms and stallion owners.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Riding school software decision tool",
        blurb: "Lesson planning, rider administration, owner portal and invoicing — all in one tool. Compare the options for riding schools and livery yards in 2026.",
        audience: "For riding schools, livery yards and equestrian businesses.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Trainer app decision tool",
        blurb: "Coaching CRM, video feedback, KNHS protocol scanning and goal tracking per combination. Which trainer app fits your coaching practice?",
        audience: "For instructors, trainers and coaches.",
      },
    ],
    closing: {
      eyebrow: "Why these guides",
      title: "Honest comparisons, not just prices.",
      body1: "Many \"comparison pages\" are disguised advertisements. Our guides place features, target audiences and competitors side by side the way an independent knowledge source would. EquiSight naturally stands out as a complete solution, but you'll also read honestly where other apps have the edge.",
      body2: "The in-depth articles under each guide answer the concrete questions that arise from the decision: \"When is the first scan after insemination\", \"How do I automate riding school invoicing\", \"How do I analyse a competition protocol\". No marketing fluff — just practical answers.",
    },
    hubName: "EquiSight Guides",
  },
  ui: {
    sectionEyebrows: {
      pains: "Why this is painful",
      basics: "Basics",
      criteria: "What makes it good?",
      comparison: "Honest comparison",
      why: "The difference",
      beforeAfter: "From fragmentation to clarity",
      helper: "5 questions",
    },
    table: {
      feature: "Feature",
      today: "Today",
      withEquisight: "With EquiSight",
    },
    helper: {
      questionLabel: "Question {{current}} of {{total}}",
      answerPrompt: "Answer the {{count}} remaining question to see a recommendation.",
      answerPromptPlural: "Answer the {{count}} remaining questions to see a recommendation.",
      resultEyebrow: "Your result",
    },
    targetGroupsFallback: "Who is this for?",
    faqTitleFallback: "Frequently asked questions",
  },
};

export default CORNERSTONES;
